import React, {
    Dispatch,
    MouseEventHandler,
    ReactNode,
    SetStateAction,
} from 'react';

import {
    findIndexById,
    intersection,
    not,
    union,
} from '../../../helpers/filterObjects';
import CustomList from '../../../../../components/TransferList/components/CustomList';
import { NameFilter } from '../../../../../components/TransferList/components/filters/NameFilter';
import { IProductsTransferListObject } from '../../../types';

interface IOwnProps<T> {
    loaded: boolean;
    nameInput: {
        name: string;
        setName: (value: string) => void;
    };
    title: string;
    items: T[];
    handleToggle: (value: T) => MouseEventHandler | undefined;
    checked: T[];
    setChecked: Dispatch<SetStateAction<T[]>>;
    tooltipTitle?: string;
    disabled?: boolean;
}

const ProductCustomList = <T extends IProductsTransferListObject>({
    loaded,
    nameInput,
    title,
    items,
    handleToggle,
    checked,
    setChecked,
    tooltipTitle,
}: IOwnProps<T>) => {
    const filterComponents = (): ReactNode => {
        return (
            <NameFilter
                id={'nameFilter'}
                label={'Find...'}
                nameInput={nameInput}
                tooltipTitle={tooltipTitle}
            />
        );
    };

    return (
        <CustomList<T>
            loaded={loaded}
            title={title}
            items={items}
            handleToggle={handleToggle}
            checked={checked}
            setChecked={setChecked}
            utils={{ intersection, union, not, findIndexById }}
            uniqueKey={(item: T) => item.relationId}
            filterComponents={filterComponents}
        />
    );
};

export default ProductCustomList;
